import { useCallback, useState } from 'react';
import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { detailRecord, DetailRecordBody } from 'services/api/remind';

function useDetailRecord() {
  const [page, setPage] = useState<PaginationProps>({
    current: 0,
    pageSize: 10,
    total: 0,
  });

  const res = useCrud({
    readList: useCallback((body: DetailRecordBody) => {
      return detailRecord(body).then((res) => {
        const { pageInfo, remindRecord } = res;

        const { pageNo: current, pageSize, totalCount: total } = pageInfo;

        setPage({
          current,
          pageSize,
          total,
        });

        return remindRecord;
      });
    }, []),
  });

  return {
    ...res,
    page,
    setPage,
  };
}

export default useDetailRecord;
